import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seleccionar-torre',
  templateUrl: './seleccionar-torre.component.html',
  styleUrls: ['./seleccionar-torre.component.css']
})
export class SeleccionarTorreComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
